export default class Iframe {
  constructor (uuid) {
    this.uuid = uuid
    this.event = null
    this.element = null
    this.ready = false
    this.handlers = {}

    // For delayed loading (see _onReady function)
    this._onReadyConfig = null

    // In JavaScript, class methods are not bound by default.
    // binding to `this` is necessary to make this callback work.
    this.handlers['ready'] = this._onReady.bind(this)

    window.addEventListener('message', (e) => {
      if (typeof e.data === 'object' && e.data.uuid === this.uuid) {
        this.dispatch(e.data.event, e.data)
      }
    })
  }

  render () {
    let iframe = document.createElement('iframe')

    iframe.setAttribute('name', 'komoju_multipay_' + Date.now())
    iframe.setAttribute('src', process.env['SECURE_IFRAME_HOST'] + '/widget.html?uuid=' + this.uuid)
    iframe.setAttribute('style', 'background-color: transparent; border: 0px none transparent; overflow: hidden; display: none; position: fixed; visibility: visible; margin: 0px; padding: 0px; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 999; -webkit-tap-highlight-color: transparent;')
    iframe.setAttribute('scrolling', 'no')
    iframe.setAttribute('allowtransparency', 'true')
    iframe.setAttribute('frameborder', '0')
    document.getElementsByTagName('body')[0].appendChild(iframe)

    this.on('close', () => { this.close() })
    this.element = iframe
  }

  open (config) {
    if (this.ready) {
      this.element.setAttribute('style', 'background-color: transparent; border: 0px none transparent; overflow: hidden; display: block; position: fixed; visibility: visible; margin: 0px; padding: 0px; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 999; -webkit-tap-highlight-color: transparent;')
      this.send('open', config)
    } else {
      // Queue widget to be opened on "ready" event
      this._onReadyConfig = config
    }
  }

  close () {
    this.element.setAttribute('style', 'background-color: transparent; border: 0px none transparent; overflow: hidden; display: none; position: fixed; visibility: visible; margin: 0px; padding: 0px; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 999; -webkit-tap-highlight-color: transparent;')
  }

  send (event, data) {
    this.element.contentWindow.postMessage({event: event, data: data, uuid: this.uuid}, process.env['SECURE_IFRAME_HOST'])
  }

  on (event, callback) {
    this.handlers[event] = callback
  }

  dispatch (event, data) {
    if (this.handlers[event]) {
      this.handlers[event](data)
    }
  }

  _onReady () {
    this.ready = true

    if (this._onReadyConfig) {
      this.open(this._onReadyConfig)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/components/multipay/Iframe.js